<template>
  <transition name="fade_right">
    <aside
      class="sidebar"
      :class="[
        getMobileSidebar ?  'sidebar--mini' : ''
      ]"
      v-show="loaded"
    >

      <div class="sidebar__header" :class="`figure-${getRole.toLowerCase()}`">
        <dr-vector
          class="sidebar__logo"
          :fill="'white'"
          :src="logo"
        />
      </div>

      <ul class="left-menu">
        <li
          v-for="route of visibleRoutes"
          :key="route.name"
          class="left-menu__item"
        >
          <span
            class="left-menu__link clickable"
            :class="fn_GET_PARENT_ROUTE(route, getRole) === fn_GET_PARENT_ROUTE($route, getRole) ? 'active' : ''"
            @click="toggleMobileSidebar(); routeGuard(route)"
          >
            <dr-icon
              :class="`TOUR_MENU_${route.name}`"
              :name="route.meta.icon"
              :fill="getColor(fn_GET_PARENT_ROUTE(route, getRole))"
            />
            {{ route.meta.title }}
          </span>
        </li>

        <!-- App Integration -->
        <li
          v-if="offices.length > 0"
          class="left-menu__item app-integration__left-menu-item"
          @mouseenter="showAppIntegrationAlert = getMobileSidebar"
          @mouseleave="showAppIntegrationAlert = false"
        >
          <router-link
            v-if="showIntegrationButton"
            :to="{ name: 'DoctorAppIntegration' }"
            tag="div"
            class="app-integration__left-menu-btn"
          >
            <dr-icon
              color="#003160"
              name="appIntegration"
              :class="getMobileSidebar && 'app-integration__left-menu-btn-icon--no-margin'"
              class="app-integration__left-menu-btn-icon"
            />
            <span v-show="!getMobileSidebar">
              Receba mais pacientes
            </span>

          </router-link>
        </li>
      </ul>

      <app-integration-alert
        :show.sync="showAppIntegrationAlert"
        parent-element="app-integration__left-menu-btn"
      />

      <small class="version">
        Versão {{ version }}
      </small>
    </aside>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import logo from '@/assets/img/logo-branco.svg'
import appIntegrationAlert from './appIntegrationAlert'
import EventBus from '@/globals/eventBus'

export default {
  components: {
    appIntegrationAlert
  },

  props: ['doctor', 'role', 'accessRoles', 'isSidebarToggled'],

  data () {
    return {
      EventBus,
      profile: {},
      visibleRoutes: [],
      showAppIntegrationAlert: false,
      version: '0.0.0',
      loaded: false,
      windowWidth: 0,
      noOffices: false,
      logo
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      appIntegration: 'getAppIntegration',
      getMobileSidebar: 'getIsSidebarToggled',
      getViewport: 'getViewport'
    }),

    showIntegrationButton () {
      const appIntegration = this.appIntegration
        ? !this.appIntegration['is_active']
        : true

      return this.fn_IS_DOCTOR() && appIntegration
    },

    getRole () {
      return this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'
    },

    getAccessRoles () {
      return this.$store.getters.getAccessRoles
    },

    getOfficesLength () {
      return this.doctor.doctor_offices.length
    }
  },

  watch: {
    getViewport (next) {
      if (next === 'tablet') {
        this.$store.dispatch('setIsSidebarToggled', true)
      }
    },
    getMobileSidebar (next) {
      if (next) {
        // document.querySelector('.section').style.maxWidth = '1160px'
        document.documentElement.style.setProperty('--size-lg', '1160px')
        document.documentElement.style.setProperty('--menu-width', 'var(--mini)')
        document.querySelector('.maincontent').style.marginLeft = '80px'
      } else {
        // document.querySelector('.section').style.maxWidth = '960px'
        document.documentElement.style.setProperty('--menu-width', 'var(--full)')
        document.documentElement.style.setProperty('--size-lg', '960px')
        document.querySelector('.maincontent').style.marginLeft = '220px'
      }
    }
  },

  mounted () {
    this.profile = this.$store.getters.getProfile
    this.noOffices = this.doctor.doctor_offices.length === 0

    this.$http
      .get(`/version`, this.$store.getters.getAuthHeader)
      .then((res) => {
        this.version = res.data
      }).catch((err) => console.log(err))

    this.initRoles()
    this.initSidebar()
  },

  methods: {
    async initRoles () {
      this.loaded = false
      const facilitiesRoutes = ['DoctorReports']
      let arr = []
      for (let route of this.fn_GET_CHILD_ROUTES(this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary')) {
        if (route.meta.sidebar) {
          if (this.fn_IS_DOCTOR()) {
            for (let facilitiesRoute of facilitiesRoutes) {
              if (facilitiesRoute === route.name) {
                if (this.fn_IS_DOCTOR()) {
                  arr.push(route)
                }
              } else {
                arr.push(route)
              }
            }
          } else {
            if (this.checkRoles(route)) {
              route.params = {
                doctorId: this.doctor.id
              }
              arr.push(route)
            }
          }
        }
      }
      if (this.fn_IS_DOCTOR()) {
        this.visibleRoutes = arr
        this.fn_HIDE_PROGRESS()
        this.loaded = true
        return
      }
      for (let route of this.$router.options.routes) {
        if (route.name === 'Secretary') {
          for (let child of route.children) {
            for (let role of child.meta.accessRoles) {
              if (this.accessRoles.join().search(role) > -1) {
                this.visibleRoutes = arr
                this.fn_HIDE_PROGRESS()
                this.loaded = true
                this.$router.replace({name: child.name})
                return
              }
            }
          }
          this.$router.replace('/secretary/user')
        }
      }
    },

    routeGuard (route) {
      const routes = [
        'DoctorAgenda',
        'DoctorPatients',
        'DoctorFinances',
        'DoctorPrices',
        'DoctorReports',
        'DoctorServices',
        'DoctorUsersOfficeList'
      ]

      if (this.getOfficesLength === 0 && routes.indexOf(route.name) > -1) {
        this.$emit('showActionModal', true)
        EventBus.$emit('show-save-office-alert')
        return
      }

      this.$router.push(
        this.fn_IS_DOCTOR()
          ? { name: route.name }
          : `/secretary/doctor/${this.doctor.id}` + route.path.split('doctorId')[1]
      )
    },

    getColor (route) {
      let color = 'gray'
      if (route === this.fn_GET_PARENT_ROUTE(this.$route, (this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'))) {
        color = 'gradient'
      }
      return color
    },

    checkRoles (r) {
      for (let accessRole of r.meta.accessRoles) {
        for (let role of this.$store.getters.getAccessRoles) {
          if (`ROLE_${accessRole}` === role) {
            return true
          }
        }
      }
    },

    getWindowWidth () {
      this.windowWidth = document.documentElement.clientWidth
    },

    toggleMobileSidebar () {
      this.$emit('toggleSidebar', false)
    },

    initSidebar () {
      const sidebar = document.querySelectorAll('.sidebar')[0] || null
      if (this.getViewport === 'tablet') {
        this.$store.dispatch('setIsSidebarToggled', true)
        document.documentElement.style.setProperty('--size-lg', '1160px')
        document.documentElement.style.setProperty('--menu-width', 'var(--mini)')
        document.querySelector('.maincontent').style.marginLeft = '80px'
      } else {
        document.documentElement.style.setProperty('--menu-width', 'var(--full)')
        document.documentElement.style.setProperty('--size-lg', '960px')
        document.querySelector('.maincontent').style.marginLeft = '220px'
      }
    }
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  }
}
</script>
